import { api } from '@/api';
import { salesPointConfigurationSelector } from '@/features/configuration/configurationSelector';
import { createAsyncThunk } from '@/store/utils';
import type {
  ConsentsResponseDTO,
  CountriesResponseDTO,
  SalesPointConfigurationResponseDTO,
  SalesPointPaymentTypesResponseDTO,
} from '@/types/dto/agent';
import type { TenantOption } from '@/types/tenant';
import {
  mapOrganizationBrandingToBrandColors,
  setTenantBrand,
  setTenantFavicon,
} from '@/utils/color';

export const setTenant = createAsyncThunk<TenantOption, TenantOption>(
  'configuration/setTenant',
  (tenant, { getState }) => {
    const organizationBranding =
      salesPointConfigurationSelector(getState())?.organizationBranding;

    setTenantBrand(
      mapOrganizationBrandingToBrandColors(organizationBranding, tenant.value)
    );
    setTenantFavicon(organizationBranding?.faviconUrl);

    return tenant;
  }
);

export const getSalesPointConfiguration =
  createAsyncThunk<SalesPointConfigurationResponseDTO>(
    'configuration/getSalesPointConfiguration',
    async () => {
      return (
        await api.agentApi.PointOfSaleConfiguration_GetSalesPointConfiguration()
      ).data;
    }
  );

export const getSalesPointPaymentTypes = createAsyncThunk<
  SalesPointPaymentTypesResponseDTO,
  string
>('configuration/getSalesPointPaymentTypes', async (salesPointId) => {
  return (
    await api.agentApi.PointOfSaleConfiguration_GetSalesPointPaymentType({
      id: salesPointId,
    })
  ).data;
});

export const getConsents = createAsyncThunk<ConsentsResponseDTO>(
  'configuration/getConsents',
  async () => {
    return (await api.agentApi.Consents_GetConsents()).data;
  }
);

export const getCountries = createAsyncThunk<CountriesResponseDTO>(
  'configuration/getCountries',
  async () => {
    return (await api.agentApi.Country_GetCountries()).data;
  }
);
